<div class="flow-card">
  <div class="card-custom-title">
    <div class="title">
      {{ scootaverse?.name }}
    </div>

    @if (!isPreview && flow?.configurationId) {
      <div class="more-options">
        <button
          type="button"
          class="kebab-btn m-l-10"
          [matMenuTriggerFor]="menu"
          [attr.data-testid]="flow?.configurationId"
        >
          <mat-icon class="kebab-menu-icon">more_vert</mat-icon>
        </button>
        <mat-menu role="menu" #menu="matMenu" xPosition="before" class="saved-rooms-options-menu">
          <button type="button" mat-menu-item role="menuitem" (click)="onEditFlow()" data-testid="edit-button">
            Edit
          </button>
          <button type="button" mat-menu-item role="menuitem" (click)="onDeleteFlow()" data-testid="delete-button">
            Delete
          </button>
        </mat-menu>
      </div>
    }
  </div>
  <div class="card-custom-body">
    <div class="pattern-container">
      <div class="pattern-image">
        @if (isFlowNotCustom) {
          <img title="Entry pattern" src="{{ getImagePath() }}" class="pattern-image-svg" />
        } @else {
          <div class="single-point-container">
            <img
              [ngStyle]="{
                left: flow?.startingPointX + '%',
                top: flow?.startingPointY + '%',
              }"
              title="Entry pattern"
              src="{{ getImagePath() }}"
              class="pattern-image-single-dot"
            />
          </div>
        }
      </div>
      <div class="pattern-title">
        {{ getPattern().title }}
      </div>
    </div>
    <div class="info-container">
      <!-- Spawn type and group size -->
      <div class="row">
        <div class="field-50">
          <div class="field-name">Spawn Type</div>
          <div class="field-value">{{ getEntryFlowSpawnTypeText() }}</div>
        </div>

        @if (flow?.groupSpawnSize) {
          <div class="field-50">
            <div class="field-name">Group Size</div>
            <div class="field-value">{{ flow?.groupSpawnSize }}</div>
          </div>
        }
      </div>

      <!-- Rooms Attached -->
      <div class="row">
        <div class="field">
          <div class="field-name">Rooms</div>
          <div class="field-value">
            {{ getAppliedRoomNames().join(', ') }}
          </div>
        </div>
      </div>

      <!-- Data Used / Starting Location -->
      @if (rulesPreview.length) {
        <div class="row">
          <div class="field">
            <div class="field-name">Data Used Group Formation</div>
            <div appShowMoreItems class="field-value wrap-badges">
              @for (rule of rulesPreview; track rule.value) {
                <div class="feature-badge">
                  <div class="badge-title">{{ rule.property }}</div>
                  <div class="badge-value">{{ rule.value }}</div>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        @if (hasCoordinates()) {
          <div class="row">
            <div class="field">
              <div class="field-name">Starting Location</div>
              <div class="field-value">{{ flow?.startingPointX }}% Left</div>
              <div class="field-value">{{ flow?.startingPointY }}% Up</div>
            </div>
          </div>
        }
      }
    </div>
  </div>
  @if (!isPreview && flow?.configurationId) {
    <div class="card-custom-footer">
      <button class="footer-edit-button" type="button" (click)="onEditFlow()" data-testid="edit-button">
        Edit
        <mat-icon class="edit-icon" svgIcon="ARROW_CIRCLE_RIGHT"></mat-icon>
      </button>
    </div>
  }
</div>
